module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scroll-hor-cont"
  }, [_c('table', {
    staticClass: "form-calculadora"
  }, [_c('tr', {
    staticClass: "form-titles"
  }, [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "font-red davi-curs "
  }, [_vm._v(_vm._s(_vm.nombresCols))])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._l((_vm.formulario), function(item) {
    return [_c('tr', {
      staticClass: "tr-space"
    }), _vm._v(" "), _vm._l((item.valores), function(itemInt, indexInt) {
      return _c('tr', {
        class: indexInt === 0 ? 'tr-header' : ''
      }, [(indexInt === 0) ? _c('td', {
        attrs: {
          "rowspan": item.valores.length
        }
      }, [_c('strong', [_c('div', {
        staticClass: "title-row font-red"
      }, [_vm._v(_vm._s(item.nombre))])])]) : _vm._e(), _vm._v(" "), _c('td', {
        staticClass: "text-xs-right"
      }, [_c('p', [_vm._v(_vm._s(itemInt.desc))])]), _vm._v(" "), _c('td', {
        staticClass: "input-td"
      }, [_c('p', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (itemInt.valor),
          expression: "itemInt.valor"
        }],
        attrs: {
          "type": "number",
          "aria-label": item.nombre,
          "name": "Valor",
          "placeholder": "Ingrese valor"
        },
        domProps: {
          "value": (itemInt.valor)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(itemInt, "valor", $event.target.value)
          }
        }
      })])])])
    })]
  }), _vm._v(" "), (_vm.nombresCols === 'Activos') ? [_c('tr', [_c('td', {
    staticClass: "text-xs-right font-red davi-curs",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Total activo")]), _vm._v(" "), _c('td', {
    staticClass: "input-td"
  }, [_c('strong', [_vm._v("$" + _vm._s(_vm.patrimonioTotalActivos))])])])] : _vm._e(), _vm._v(" "), (_vm.nombresCols === 'Pasivos') ? [_c('tr', [_c('td', {
    staticClass: "text-xs-right font-red davi-curs",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Total activo")]), _vm._v(" "), _c('td', {
    staticClass: "input-td"
  }, [_c('strong', [_vm._v("$" + _vm._s(_vm.patrimonioTotalActivos))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-xs-right font-red davi-curs",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Menos (-) Total pasivo")]), _vm._v(" "), _c('td', {
    staticClass: "input-td"
  }, [_c('strong', [_vm._v("$" + _vm._s(_vm.patrimonioTotalPasivos))])])]), _vm._v(" "), _c('tr', [_vm._m(1), _vm._v(" "), _c('td', {
    staticClass: "input-td"
  }, [_c('strong', [_vm._v("$" + _vm._s(_vm.diferenciaPatrimonio))])])])] : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "font-red davi-curs"
  }, [_c('p', {
    staticClass: "font-red davi-curs "
  }, [_vm._v("Valor")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-xs-right",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "davi-curs"
  }, [_vm._v("Patrimonio")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e86132c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/FormCalculadoraPatrimonio.vue
// module id = 1055
// module chunks = 1